import React from 'react';
import { Img, Neon } from '../../components';

import {
	Tag,
	Card,
	Cards,
	Wrapper,
	TagList,
	CardDate,
	CardTitle,
	CardContent,
	CardExcerpt,
	ThumbnailWrapper,
} from './Tiles.styled';

export default function Tiles({ data, title, color }) {
	return (
		<Wrapper>
			{title && (
				<Neon as="h1" color={color}>
					{title}
				</Neon>
			)}
			{data && (
				<Cards>
					{data.map(
						item =>
							item.frontmatter.status === 'public' && (
								<Card
									to={`/${
										item.frontmatter.type === 'post'
											? 'blog'
											: 'projects'
									}/${item.frontmatter.slug}`}
									key={item.id}
								>
									<ThumbnailWrapper>
										<Img
											src={
												item.frontmatter.image
													.childImageSharp
													.gatsbyImageData
											}
											alt={item.frontmatter.title}
										/>
										<div className="overlay"></div>
									</ThumbnailWrapper>

									<CardContent>
										<CardDate>
											{item.frontmatter.date}
										</CardDate>
										<CardTitle>
											{item.frontmatter.title}
										</CardTitle>
										<CardExcerpt>
											{item.frontmatter.subtitle}
										</CardExcerpt>

										{item.frontmatter.tags && (
											<TagList>
												{item.frontmatter.tags.map(
													tag => (
														<Tag key={tag}>
															{tag}
														</Tag>
													),
												)}
											</TagList>
										)}
									</CardContent>
								</Card>
							),
					)}
				</Cards>
			)}
		</Wrapper>
	);
}
